<template>
    <div
        :class="{
            'has-error': hasErrors
        }"
    >
        <label :for="name" class="label-checkbox" :class="[isChecked ? 'text-black high-contrast:text-yellow-300' : 'text-grey-200 high-contrast:text-yellow-300/75']">
            <span class="mt-1">
                <input
                    type="checkbox"
                    name="name"
                    true-value="label"
                    :value="label"
                    :id="name"
                    :checked="value"
                    @change="$emit('input', $event.target.checked)"
                />
                <i :class="{'border border-grey bg-transparent rounded p-2 high-contrast:border-yellow-300': true, 'border-orange': hasErrors}"></i>
            </span>
            <div class="inline-block checkbox-text font-light" :class="labelClass">
                {{ __(label) }}
                <span v-html="HTMLcontent"></span>
            </div>
        </label>
        <span
            v-for="(error, index) in inputErrors"
            v-bind:key="`error-${index}`"
            class="validation-error">
                {{ error }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        name: {
            type: String,
            required: true
        },
        HTMLcontent: String,
        label: String,
        labelClass: {
            type: String,
            default: 'text-1375xl'
        },
        errors: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        hasValue() {
            return !_.isEmpty(this.value);
        },
        hasErrors() {
            return _.isArray(this.inputErrors) && this.inputErrors.length > 0;
        },
        inputErrors() {
            return _.get(this.errors, this.name, []);
        },
        isChecked() {
            return this.value;
        }
    }
};
</script>
